module.exports = __webpack_public_path__ + "img/Group11@1.5x.946737f1.svg";